import { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { sessionStartHeapAtom } from '../../atoms/session-atoms';
import { getHeapTags } from '../../utils/performance-tag-helpers';

/**
 * Captures JS heap usage at session mount as a baseline for growth tracking.
 * Chrome-only; no-op when performance.memory is unavailable (heap = 0).
 * Mount once at studio root level via PerformanceInitializer.
 */
export function useSessionStartHeap() {
  const setSessionStartHeap = useSetAtom(sessionStartHeapAtom);
  useEffect(() => {
    const heap = getHeapTags().browserHeapUsed;
    if (heap > 0) {
      setSessionStartHeap(heap);
    }
  }, [setSessionStartHeap]);
}